import { createRoute, Outlet } from "@tanstack/react-router";
import { appRoute } from "./parent-routes";
import IncidentSearchForm from "../../modules/incident-management/pages/IncidentSearchForm";
import IncidentForm from "../../modules/incident-management/pages/IncidentForm";

const incidentManagementRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "incident-management",
  component: Outlet,
  staticData: {
    handle: { title: "Incident Management" },
  },
});

const incidentSearchIndexRoute = createRoute({
  getParentRoute: () => incidentManagementRoute,
  path: "/",
  component: IncidentSearchForm,
  staticData: {
    handle: { title: "Incident Management" },
  },
});

const incidentDisplayRoute = createRoute({
  getParentRoute: () => incidentManagementRoute,
  path: "$id/display",
  component: IncidentForm,
  staticData: {
    handle: { title: "View Incident Record", action: "display" },
  },
});

const incidentEditRoute = createRoute({
  getParentRoute: () => incidentManagementRoute,
  path: "$id/edit",
  component: IncidentForm,
  staticData: {
    handle: { title: "Edit Incident Record", action: "edit" },
  },
});

const incidentManagementRouteTree = incidentManagementRoute.addChildren([
  incidentSearchIndexRoute,
  incidentDisplayRoute,
  incidentEditRoute,
]);

export default incidentManagementRouteTree;
